import { useState } from 'react'
import { router } from '@inertiajs/react'
import Logo from '../../components/Logo'

export default function SelectWorkspace({ nonce, workspaces }) {
  const [selectedId, setSelectedId] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    if (selectedId === null) return
    setSubmitting(true)
    router.post('/oauth/select_workspace', { workspace_id: selectedId, nonce }, {
      onFinish: () => setSubmitting(false),
    })
  }

  return (
    <div className="min-h-screen bg-zinc-900 flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[500px] h-[500px] rounded-full bg-indigo-900/8 blur-3xl" />
      </div>

      <div className="w-full max-w-sm relative z-10">
        <div className="mb-10 flex justify-center">
          <div className="flex flex-col items-center gap-5">
            <Logo variant="mark" size={120} />
            <p className="text-sm font-mono font-bold tracking-[0.5em] uppercase text-emerald-300">anamnesis</p>
          </div>
        </div>

        <div className="bg-zinc-800/30 border border-zinc-600/50 rounded-2xl p-6">
          <div className="mb-5">
            <h2 className="text-xs font-mono font-bold text-zinc-300 mb-1 uppercase tracking-widest">
              Select a workspace
            </h2>
            <p className="text-xs font-mono text-zinc-600">
              Choose which workspace to authorize for this application.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-2">
            {workspaces.map(ws => (
              <label
                key={ws.id}
                className={[
                  'flex items-center gap-3 px-4 py-3 rounded-lg border cursor-pointer transition-all',
                  selectedId === ws.id
                    ? 'border-emerald-600/60 bg-emerald-900/20 shadow-[0_0_12px_0_theme(colors.emerald.900/30)]'
                    : 'border-zinc-700 bg-zinc-800/40 hover:border-zinc-600',
                ].join(' ')}
              >
                <input
                  type="radio"
                  name="workspace_id"
                  value={ws.id}
                  checked={selectedId === ws.id}
                  onChange={() => setSelectedId(ws.id)}
                  className="accent-emerald-500"
                />
                <div className="flex-1 min-w-0">
                  <span className="block text-sm font-mono text-zinc-100 truncate">
                    {ws.name}
                  </span>
                  {ws.kind && (
                    <span className="inline-block mt-0.5 text-[10px] font-mono text-zinc-500 uppercase tracking-wider">
                      {ws.kind}
                    </span>
                  )}
                </div>
              </label>
            ))}

            <div className="pt-3">
              <button
                type="submit"
                disabled={selectedId === null || submitting}
                className="w-full bg-emerald-800/60 hover:bg-emerald-700/80 disabled:opacity-50 disabled:cursor-not-allowed text-emerald-200 border border-emerald-700/40 font-mono text-sm font-semibold py-2.5 px-4 rounded-lg transition-colors"
              >
                {submitting ? 'Authorizing...' : 'Continue'}
              </button>
            </div>
          </form>
        </div>

        <p className="mt-6 text-center text-[10px] font-mono text-zinc-500 tracking-wider uppercase">
          persistent memory for AI agents
        </p>
      </div>
    </div>
  )
}
